import { useEffect, useMemo, useState } from 'react';
import Router from './Router';
import { IHttpService, HttpService } from '../services/httpService';
import { Loader } from './loader/Loader';

const App = (): JSX.Element => {
	const httpService: IHttpService = useMemo(() => new HttpService(), []);

	const [loading, setLoading] = useState<boolean>(true);
	const [healthStatus, setHealthStatus] = useState<string>('');

	useEffect(() => {
		const checkApiHealth = async () => {
			try {
				const response = await httpService.get<string>(
					`api/health`,
					undefined
				);

				setHealthStatus(response);
			} catch (error) {
				setHealthStatus('Unhealthy');
			} finally {
				setLoading(false);
			}
		};

		checkApiHealth();
	}, []);

	if (loading) {
		return <Loader />;
	}

	if (!loading && healthStatus === 'Healthy') {
		return <Router />;
	}

	throw new Error('API not responding');
};

export default App;
